export default "__VITE_ASSET__CyzrMA6y__"